

<script lang="ts">
  import type { PermissionState } from "@kontextwerk/control-web-frame/shared/logic/authorization"
  import type { PropertiesViewFrameContext } from "../../context"
  import type { PageTabWithId } from "@kontextwerk/web-sdk/core/navigation/viewNavigation"
  import type { PageContext } from "./navigation"
  import GeneralContent from "./_modules/general-content"

  const { viewFrameContext, activeTab } = $props<{
    viewFrameContext: PropertiesViewFrameContext
    activeTab: string
  }>()

  const pageContext = $derived.by<PageContext>(() => ({
    permissions: viewFrameContext.permissions,
    property: viewFrameContext.property,
    organizationId: viewFrameContext.organizationId,
    canEditCustomers: viewFrameContext.canEditCustomers,
    loading: viewFrameContext.loading,
    error: viewFrameContext.error,
    saving: viewFrameContext.saving,
    onRetry: viewFrameContext.onRetry,
    onSubmit: viewFrameContext.onSubmit,
  }))
</script>

{#if activeTab === "general"}
  <GeneralContent
    property={pageContext.property}
    organizationId={pageContext.organizationId}
    loading={pageContext.loading}
    error={pageContext.error}
    saving={pageContext.saving}
    canEdit={pageContext.canEditCustomers}
    onRetry={pageContext.onRetry}
    onSubmit={pageContext.onSubmit}
  />
{/if}
